import { livePresentationTarget } from "./presentation";
import type { WorkspaceState } from "../types";

/** The DM reopens on the authoritative live presentation, then falls back to campaign preparation state. */
export function initialDmSceneId(state: WorkspaceState): string | undefined {
  const liveId = livePresentationTarget(state.presentation);
  if (liveId && state.scenes.some((scene) => scene.id === liveId)) return liveId;
  const activeCampaign = state.campaigns.find((campaign) => campaign.id === state.settings.activeCampaignId);
  if (activeCampaign?.activeSceneId && state.scenes.some((scene) => scene.id === activeCampaign.activeSceneId)) return activeCampaign.activeSceneId;
  return state.scenes[0]?.id;
}
